module.exports = __webpack_public_path__ + "static/ferry-dfde8704c4c54e25edbb8b91985e92b8.png";